var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWavecontact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "wave",
    style: {
      transform: "rotate(180deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 440",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(39.788, 54.757, 90.668, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(44.46, 43.886, 97.499, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,132L80,117.3C160,103,320,73,480,88C640,103,800,161,960,183.3C1120,205,1280,191,1440,161.3C1600,132,1760,88,1920,110C2080,132,2240,220,2400,249.3C2560,279,2720,249,2880,205.3C3040,161,3200,103,3360,132C3520,161,3680,279,3840,278.7C4000,279,4160,161,4320,117.3C4480,73,4640,103,4800,110C4960,117,5120,103,5280,124.7C5440,147,5600,205,5760,256.7C5920,308,6080,352,6240,344.7C6400,337,6560,279,6720,234.7C6880,191,7040,161,7200,146.7C7360,132,7520,132,7680,161.3C7840,191,8000,249,8160,256.7C8320,264,8480,220,8640,227.3C8800,235,8960,293,9120,330C9280,367,9440,381,9600,344.7C9760,308,9920,220,10080,161.3C10240,103,10400,73,10560,88C10720,103,10880,161,11040,154C11200,147,11360,73,11440,36.7L11520,0L11520,440L11440,440C11360,440,11200,440,11040,440C10880,440,10720,440,10560,440C10400,440,10240,440,10080,440C9920,440,9760,440,9600,440C9440,440,9280,440,9120,440C8960,440,8800,440,8640,440C8480,440,8320,440,8160,440C8000,440,7840,440,7680,440C7520,440,7360,440,7200,440C7040,440,6880,440,6720,440C6560,440,6400,440,6240,440C6080,440,5920,440,5760,440C5600,440,5440,440,5280,440C5120,440,4960,440,4800,440C4640,440,4480,440,4320,440C4160,440,4000,440,3840,440C3680,440,3520,440,3360,440C3200,440,3040,440,2880,440C2720,440,2560,440,2400,440C2240,440,2080,440,1920,440C1760,440,1600,440,1440,440C1280,440,1120,440,960,440C800,440,640,440,480,440C320,440,160,440,80,440L0,440Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavecontact);
export default __webpack_public_path__ + "static/media/wave contact.934b118a69ec87ceca399e6ef160f4ae.svg";
export { ForwardRef as ReactComponent };